<template>
  <div>
    <slot name="label">
      <h2 class="mb-0">{{ $t('personalizedWalletCard.customize.temperament.label') }}</h2>
    </slot>
    <b-row class="mx-0">
      <b-col class="px-0">
        <dp-pet-temperament
          v-model="selectedTemperaments"
          class="notranslate"
          :temperaments="options"
          translate="no"
          @selectedTemperaments="selectTemperaments"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { DpPetTemperament } from '@docupet/component-library';
export default {
  name: 'WalletCardTemperamentSelect',
  components: {
    DpPetTemperament,
  },
  props: {
    options: {
      type: Array,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      selectedTemperaments: null,
    };
  },
  created() {},
  methods: {
    selectTemperaments(temperaments) {
      this.selectedTemperaments = temperaments;
      this.$emit('selectedTemperaments', temperaments);
    },
  },
};
</script>

<style lang="scss" scoped></style>
